import call from "../cassandra-base/service/http";
import attendanceConstants from "./attendanceConstants";
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";
import constants from "@/packages/cassandra-grievances/constants";

export default {
  namespaced: true,
  state: {
    requests: [],
    logs: [],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    attendanceGetters: (state) => (val) => state[val],
  },
  actions: {
    getAttendanceRequests: ({ commit }, payload) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", attendanceConstants.requests(payload.employeeNo))
        .then((response) => {
          commit("MUTATE", {
            state: "requests",
            data: response.data.data,
          });
          commit("loader/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("loader/SET_LOADING", false, { root: true });
          console.log(error);
        });
    },
    getAttendanceLogs: ({ commit }, payload) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", attendanceConstants.logs, payload)
        .then((response) => {
          commit("MUTATE", {
            state: "logs",
            data: response.data.data.shift(),
          });
          commit("loader/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("loader/SET_LOADING", false, { root: true });
          console.log(error);
        });
    },
    createRequest: async ({ commit, dispatch }, payload) => {
      try {
        await call("post", attendanceConstants.createRequest, payload);
        Event.$emit("ApiSuccess", "You've checked in successfully");
        dispatch("getAttendanceRequests", { employeeNo: payload.employeeNo });
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    requestApproval: ({ commit, dispatch }, payload) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", attendanceConstants.requestApproval, payload)
        .then((response) => {
          commit("loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Approval request submitted successfully");
          dispatch("getAttendanceRequests", { employeeNo: payload.employeeNo });
        })
        .catch((error) => {
          commit("loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
